<kl-form-container
  [title]="title + (mode === 'edit' || mode === 'view' ? entity.code : '')"
  [mode]="mode"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [alertType]="alertType"
  (onCloseAlert)="alertShow = false"
  (onCommitSave)="commitSave($event)"
>
  <form
    #MaterialSpeCodeForm="ngForm"
    class="modal-form"
    style="overflow: unset !important"
    novalidate
  >
    <div class="col-md-12 col-sm-12">
      <div class="form-group row">
        <label for="tour" class="col-md-3 col-sm-12">
          <small>{{ "type" | translate }}</small>
        </label>
        <div class="col-md-9 col-sm-12">
          <p-dropdown
            [emptyFilterMessage]="'not_found' | translate"
            [options]="typeOptions"
            [(ngModel)]="entity.type"
            (onChange)="formChange(true)"
            [disabled]="isReadOnly"
            name="tour"
            id="tour"
            [filter]="true"
            [style]="{ width: '100%' }"
          >
          </p-dropdown>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3 col-sm12">
          <label for="MaterialSpeCodeCode">
            <small>{{ "code" | translate }} <i class="text-danger">*</i></small>
          </label>
        </div>
        <div class="col-md-9 col-sm12">
          <input
            type="text"
            class="form-control form-control-sm"
            #focusElement
            [disabled]="isReadOnly"
            #MaterialSpeCodeCode="ngModel"
            name="MaterialSpeCodeCode"
            [ngClass]="
              alertShow && MaterialSpeCodeCode.invalid ? 'errorInput' : ''
            "
            [(ngModel)]="entity.code"
            (ngModelChange)="formChange(true)"
            id="MaterialSpeCodeCode"
            maxlength="20"
            required
          />
          <div
            *ngIf="alertShow && MaterialSpeCodeCode.invalid"
            class="errorMessage"
          >
            {{ "important_area" | translate }}
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3 col-sm12">
          <label for="MaterialSpeCodeName">
            <small
              >{{ "description" | translate }}
              <i class="text-danger">*</i></small
            >
          </label>
        </div>
        <div class="col-md-9 col-sm12">
          <input
            type="text"
            class="form-control form-control-sm"
            name="MaterialSpeCodeName"
            #MaterialSpeCodeName="ngModel"
            [disabled]="isReadOnly"
            [ngClass]="
              alertShow && MaterialSpeCodeName.invalid ? 'errorInput' : ''
            "
            [(ngModel)]="entity.description"
            (ngModelChange)="formChange(true)"
            id="MaterialSpeCodeName"
            maxlength="50"
            required
          />
          <div
            *ngIf="alertShow && MaterialSpeCodeName.invalid"
            class="errorMessage"
          >
            {{ "important_area" | translate }}
          </div>
        </div>
      </div>
    </div>
  </form>
</kl-form-container>
